import {
  Snackbar,
  Box,
  Typography,
  IconButton,
  LinearProgress,
} from '@mui/material'
import NotificationsIcon from '@mui/icons-material/Notifications'
import CloseIcon from '@mui/icons-material/Close'
import { toastBoxSx, toastProgressSx } from '../styles/NotificationStyle'

export default function NotificationToast({ toast, progress, onClose }) {
  return (
    <Snackbar
      open={Boolean(toast)}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {toast && (
        <Box sx={toastBoxSx}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <NotificationsIcon sx={{ mr: 1 }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {toast.event_subject}
              </Typography>
              <Typography variant="body2">{toast.event_body || ''}</Typography>
            </Box>
            <IconButton size="small" sx={{ color: 'white' }} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={toastProgressSx}
          />
        </Box>
      )}
    </Snackbar>
  )
}
